// Core timing + tuning constants. Everything in this file is authored to match
// StarCraft: Brood War on "Fastest" game speed, where 1 game second == 1 real
// second == 24 logic frames.

export const TICK_RATE = 24;                 // logic frames per second
export const TICK_DT = 1 / TICK_RATE;        // seconds per logic frame
export const TICK_MS = 1000 / TICK_RATE;

export const MAP_W = 96;                     // tiles
export const MAP_H = 96;

export const MAX_SUPPLY = 200;
export const SELECTION_LIMIT = 24;           // BW is 12; 24 is a deliberate QoL deviation
export const CONTROL_GROUPS = 10;

// --- Economy tuning -------------------------------------------------------
// Derived so that one worker yields ~50 minerals/min and a mineral patch
// saturates at ~2 workers (mine time == round-trip travel time). See README.
export const MINERALS_PER_TRIP = 5;
export const GAS_PER_TRIP = 5;
export const MINE_DURATION = 3.0;            // seconds clamped onto a patch
export const GAS_DURATION = 3.0;
export const PATCH_AMOUNT = 1500;
export const GEYSER_AMOUNT = 5000;
export const GAS_WORKER_CAP = 3;             // hard cap per refinery, like BW

export const START_MINERALS = 50;
export const START_GAS = 0;
export const START_WORKERS = 4;

// --- Combat tuning --------------------------------------------------------
export const MIN_DAMAGE = 1;                 // damage floor after armor
export const ACQUIRE_RANGE_BONUS = 2.0;      // how far past weapon range a unit auto-acquires
export const LEASH_RANGE = 6.0;              // how far a unit chases off its post before returning

// Damage type multipliers vs unit size class: [small, medium, large]
export const DAMAGE_TABLE = {
  normal:     [1.0, 1.0, 1.0],
  explosive:  [0.5, 0.75, 1.0],
  concussive: [1.0, 0.5, 0.25],
};

// --- Movement tuning ------------------------------------------------------
export const SEPARATION_STRENGTH = 2.2;
export const ARRIVE_EPSILON = 0.25;          // tiles
export const STUCK_TICKS = 20;               // ticks of no progress before giving up
export const FLOWFIELD_CACHE = 48;           // LRU size

// --- Fog of war -----------------------------------------------------------
export const FOG_UNEXPLORED = 0;
export const FOG_EXPLORED = 1;
export const FOG_VISIBLE = 2;

export const PLAYER = 0;
export const ENEMY = 1;
